export default __webpack_public_path__ + "static/media/Avatar_Holy.0fbabd77.png";